import { watch } from 'vue'
import { useRouter } from 'vue-router'
import { useCookieConsent } from './useCookieConsent'

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined

let initialized = false

function loadGAScript(id: string) {
  if (initialized || !id) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  document.head.appendChild(script)

  ;(window as any).dataLayer = (window as any).dataLayer || []
  function gtag(...args: any[]) {
    ;(window as any).dataLayer.push(args)
  }
  ;(window as any).gtag = gtag

  gtag('js', new Date())
  gtag('config', id, { send_page_view: false })

  initialized = true
}

function trackPageView(path: string, title: string) {
  if (!initialized || !(window as any).gtag) return
  ;(window as any).gtag('event', 'page_view', {
    page_path: path,
    page_title: title
  })
}

export function useAnalytics() {
  const { preferences, hasConsented } = useCookieConsent()

  if (!GA_ID) return

  // Watch consent and load GA when analytics is accepted
  watch(
    () => preferences.value.analytics,
    (allowed) => {
      if (allowed && hasConsented.value) {
        loadGAScript(GA_ID!)
      }
    },
    { immediate: true }
  )

  // Track page views on route changes
  const router = useRouter()
  router.afterEach((to) => {
    if (preferences.value.analytics && initialized) {
      trackPageView(to.fullPath, document.title)
    }
  })
}
